import React from "react";
import ListFilterPanel from "@/components/Shared/Filters/ListFilterPanel";
import {
	EMPTY_JOB_DEFINITION,
	JobFilterDefinition,
	JobSavedFilter,
	isEmptyJobDefinition,
	jobDefinitionsEqual,
} from "../../../models/JobFilter";
import JobFilterBuilder from "./JobFilterBuilder";
import { JobFilterOptions } from "./useJobFilterData";

interface Props {
	isOpen: boolean;
	onClose: () => void;
	definition: JobFilterDefinition;
	onChange: (def: JobFilterDefinition) => void;
	options: JobFilterOptions;
	savedFilters: JobSavedFilter[];
	/** org-defined filters, shown read-only in the manage view for context */
	orgFilters?: JobSavedFilter[];
	/** id of the saved filter currently being edited (the "base"), if any */
	activeSavedId?: string;
	onSaveNew: (name: string, def: JobFilterDefinition) => void;
	onUpdateSaved: (id: string, def: JobFilterDefinition) => void;
	onRenameSaved: (id: string, name: string) => void;
	onDeleteSaved: (id: string) => void;
	onReorderSaved: (ordered: JobSavedFilter[]) => void;
}

/**
 * The job list's filter drawer. A thin wrapper over the shared `ListFilterPanel`,
 * supplying the `JobFilterBuilder` and the job definition's empty/equality
 * helpers.
 */
const JobFilterPanel: React.FC<Props> = ({ options, ...rest }) => (
	<ListFilterPanel
		{...rest}
		isEmptyDefinition={isEmptyJobDefinition}
		definitionsEqual={jobDefinitionsEqual}
		emptyDefinition={EMPTY_JOB_DEFINITION}
		renderBuilder={(def, change) => (
			<JobFilterBuilder definition={def} onChange={change} options={options} />
		)}
	/>
);

export default JobFilterPanel;
